export const enum PayorEnum {
  SimplyMCR = 93,
  SimplyClear = 164,
  SimplyMMA = 176,
  SimplyFHK = 225,
  FloridaCommunityCare = 217,
  OptimumHealthcare = 302,
  FreedomHealth = 303,
  OneHealthTrasnportation = 7,
  FloridaCompleteCare = 321,
  Centrum = 88,
  Testing = 253
}



// WEBPACK FOOTER //
// ./src/app/core/enums/payor.enum.ts